(() => {
  function init(scope) {
    scope.querySelectorAll('[data-merci-github]').forEach((root) => {
      if (root.dataset.ready) return;
      root.dataset.ready = 'true';
      const images = JSON.parse(root.querySelector('[data-merci-images]').textContent);
      const wall = root.querySelector('[data-merci-wall]');
      // Build enough columns for the current viewport, preserving the supplied design.
      const count = Math.max(4, Math.ceil((window.innerWidth + 120) / (window.innerWidth <= 560 ? 116 : 178)));
      for (let c = 0; c < count; c++) {
        const column = document.createElement('div');
        column.className = 'ines-merci-github__col';
        column.style.animationDuration = `${40 + ((c * 7) % 5) * 6}s`;
        column.style.animationDelay = `-${(c * 13) % 40}s`;
        const list = Array.from({ length: 8 }, (_, k) => images[(c * 5 + k * 3) % images.length]);
        list.concat(list).forEach((src) => {
          const image = document.createElement('img');
          image.src = src;
          image.alt = '';
          image.width = 707;
          image.height = 1000;
          image.decoding = 'async';
          column.appendChild(image);
        });
        wall.appendChild(column);
      }
      const pause = root.querySelector('[data-merci-pause]');
      pause.hidden = false;
      pause.addEventListener('click', () => {
        const paused = root.dataset.paused !== 'true';
        root.dataset.paused = String(paused);
        pause.setAttribute('aria-pressed', String(paused));
        pause.textContent = paused ? 'Animer le fond' : 'Mettre le fond en pause';
      });
      const button = root.querySelector('[data-merci-copy]');
      button.hidden = false;
      button.addEventListener('click', async () => {
        const status = root.querySelector('[data-merci-status]');
        let timeout;
        try {
          await Promise.race([
            navigator.clipboard.writeText(root.querySelector('[data-merci-code]').textContent.trim()),
            new Promise((_, reject) => { timeout = setTimeout(() => reject(new Error('clipboard_timeout')), 2000); }),
          ]);
          button.textContent = 'Copié ✓';
          button.classList.add('ines-merci-github__ok');
          status.textContent = 'Le code MERCI30 est copié.';
        } catch (_) {
          status.textContent = 'Sélectionne MERCI30 pour copier le code.';
        } finally {
          clearTimeout(timeout);
        }
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document));
  else init(document);
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
